import React from 'react';
import { brands } from '../mock';

const Brands = () => {
  const doubled = [...brands, ...brands, ...brands];
  return (
    <section className="brands-section">
      <div className="brands-label">Tüm Markalara Hizmet Veriyoruz</div>
      <div className="brands-marquee">
        <div className="brands-track">
          {doubled.map((b, i) => (
            <span key={i} className="brand-item">{b}</span>
          ))}
        </div>
      </div>
      <p className="brands-footer">
        Tüm marka ve model araçlara döşeme hizmeti veriyoruz — özel teklif için iletişime geçin
      </p>
    </section>
  );
};

export default Brands;
